export default "__VITE_ASSET__CLeQa$qv__"